function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { Input, Button, Divider, Form, Alert, InputNumber, Modal, Descriptions } from "antd";
import Common from '../includes/Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var NewProvision = function NewProvision(_ref) {
  var item = _ref.item,
      handler = _ref.handler;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      formError = _useState2[0],
      setFormError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFormLoading = _useState4[0],
      setIsFormLoading = _useState4[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setFormError('');
    setIsFormLoading(true);
    Modal.confirm({
      title: "Confirmez-vous ?",
      content: "Opération entrée de " + values.quantity + " " + item.label,
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "makeconsumableprovision", {
          id: item.id.toString(),
          quantity: values.quantity,
          note: values.note
        }).then(function (response) {
          if (response.data.status == 200) {
            handler();
          } else {
            setFormError(response.data.message);
          }
        })["catch"](function (error) {
          setFormError('Une erreur est survenue');
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      comment: ''
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Descriptions, {
      title: /*#__PURE__*/_jsx("b", {
        children: item.label
      }),
      column: 1,
      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
        label: /*#__PURE__*/_jsx("b", {
          children: "CATEGORIE"
        }),
        children: item.category.label
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: /*#__PURE__*/_jsx("b", {
          children: "QTE DISPONIBLE"
        }),
        children: item.available_quantity
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h5", {
      children: /*#__PURE__*/_jsx("b", {
        children: "NOUVELLE ENTREE"
      })
    }), /*#__PURE__*/_jsx("br", {}), formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      onFinish: onFinish,
      layout: "vertical",
      size: "large",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: "Quantit\xE9",
        name: "quantity",
        rules: [{
          required: true,
          message: 'Champ obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Commentaire",
        name: "note",
        children: /*#__PURE__*/_jsx(TextArea, {
          autoSize: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          loading: isFormLoading,
          htmlType: "submit",
          children: "VALIDER"
        })
      })]
    })]
  });
};

export default NewProvision;